import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/residents/visitor-inquiry";

export const Route = createFileRoute("/admin/_residents/visitor-inquiry")({
  component: Page,
});
